import '@css/toast.css';
import 'toastr/build/toastr.css';
import toastr from 'toastr';

const showToast = (message, type = 'success', position = 'top-right', timeout = 3000, options = {}) => {
    toastr.options = {
        closeButton: true,
        debug: false,
        newestOnTop: true,
        progressBar: true,
        positionClass: `toast-${position}`,
        timeOut: timeout,
        showDuration: '300',
        hideDuration: '1000',
        extendedTimeOut: timeout,
        preventDuplicates: false,
        onclick: null,
        showEasing: 'swing',
        hideEasing: 'linear',
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut',
        ...options
    };
    toastr[type](message);
};

export { showToast };
